
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSnowColour as ObiSnowColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-snow-colour.js';
 
 
 

 
 export const ObiSnowColour = createComponent({
   react: React,
   tagName: 'obi-snow-colour',
   elementClass: ObiSnowColourElement,
   events: {
     
   }
  });
 
 